// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import type {State as ReduxState} from '../../reducers';
import TripBoardButton from '@homeaway/react-trip-board-button';
import type {State as AbacusState} from '../../reducers/abacus';

import type {
    ListingShape as HitListingShape,
    SERPHitShape as HitSERPHitShape
} from '../Hit/Hit';

type StateProps = {
    abacus: AbacusState,
    adultsCount?: number,
    childrenCount?: number,
    endDate?: string,
    petIncluded?: boolean,
    siteName: string,
    startDate?: string
};

export type Props = {
    hit: HitSERPHitShape,
    listing: HitListingShape,
    isMapHit?: boolean
} & StateProps;

const TripBoardComponent = ({
    abacus,
    adultsCount,
    childrenCount,
    endDate,
    hit: {thumbnailUrl1},
    listing: {
        propertyMetadata: {headline},
        listingId,
        averageRating,
        reviewCount
    },
    isMapHit,
    petIncluded,
    siteName,
    startDate
}: Props) => (
    <TripBoardButton
        abacus={abacus}
        adultsCount={adultsCount}
        childrenCount={childrenCount}
        endDate={endDate}
        headline={headline}
        listingId={listingId}
        position="left"
        rating={averageRating}
        reviewCount={reviewCount}
        petIncluded={petIncluded}
        siteName={siteName}
        startDate={startDate}
        thumbnailUrl={thumbnailUrl1}
        useNativeEventListener={isMapHit}
    />
);

const mapStateToProps = (state: ReduxState): StateProps => {
    const {abacus, searchParams, system} = state;
    const siteName = system.siteName;
    const {
        arrival: startDate,
        departure: endDate,
        adultsCount,
        childrenCount,
        petIncluded
    } = searchParams.params;

    return {
        abacus,
        adultsCount,
        childrenCount,
        endDate,
        petIncluded,
        siteName,
        startDate
    };
};

export default compose(connect(mapStateToProps))(TripBoardComponent);
